<template>
  <div class="container">
    <!-- 针对阿里云播放器： -->
    <div id="J_prismPlayer"></div>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    videoId: {
      type: String | Number
    }
  },
  components: {},
  data() {
    return {}
  },
  watch: {
    videoId: {
      handler(nVal) {
        this.getVideoUrl()
      },
      immediate: true
    }
  },
  methods: {
    async getVideoUrl() {
      try {
        const result = await this.$http.getVideoInfo({ videoId: this.videoId })
        if (result.code !== 200) return
        const videoUrl = result.rt.storage || ''
        // const videoUrl = 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4' // TODO: 本地调试
        this.initAliplayerVideo(videoUrl)
      } catch (error) {
        console.log(error, 'error')
      }
    },
    // 初始化阿里播放器：
    initAliplayerVideo(url) {
      const props = {
        id: 'J_prismPlayer',
        width: '100%',
        height: '100%',
        autoplay: false,
        preload: true,
        controlBarVisibility: 'always',
        useH5Prism: true,
        playsinline: true,
        isLive: false,
        language: 'zh-cn',
        // source: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4', // 播放地址
        // source: 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8', // 播放地址
        // cover: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202209/295eedc2dcb54965b1fe17e64b352d95.png', // 封面地址
        source: '',
        cover: '',
        components: [],
        skinLayout: [
          // { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          { name: 'bigPlayButton', align: 'cc' },
          { name: 'H5Loading', align: 'cc' },
          // {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          { name: 'infoDisplay', align: 'cc' },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              { name: 'progress', align: 'blabs', x: 0, y: 44 },
              { name: 'playButton', align: 'tl', x: 15, y: 14 },
              { name: 'timeDisplay', align: 'tl', x: 10, y: 9 },
              { name: 'fullScreenButton', align: 'tr', x: 10, y: 14 },
              // { name: "subtitle", align: "tr", x:15, y:14 },
              { name: 'setting', align: 'tr', x: 15, y: 14 },
              { name: 'volume', align: 'tr', x: 12, y: 12 }
            ]
          }
        ]
      }
      this.$nextTick(() => {
        // init：
        this.playerForAliplayer = new Aliplayer(props, function (playerForAliplayer) {
          // console.log(playerForAliplayer, 'playerForAliplayer_video_in')
          // console.log(url, 'playerForAliplayer_url_in')
        })
        // console.log(url, 'playerForAliplayer_url_outer')
        // console.log(this.playerForAliplayer, 'playerForAliplayer_video_outer')
        url && this.playerForAliplayer.loadByUrl(url)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
